import {ActionLink} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const DictionaryLink = (context: NavigationContext): ActionLink => ({
        type: 'actionLink',
        label: 'navigation.dictionary',
        link: context.dictionary.link,
        icon: 'navigation-link__list-item',
        action: context.dictionary.action,
    }
);